import { Fragment, useRef } from "react";
import "./Team.scss";
import { motion } from "framer-motion";
import { FaFacebookF } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedinIn } from "react-icons/fa6";
import { baseUrl } from "../../../utils/apiData";

import { HiOutlineArrowNarrowLeft } from "react-icons/hi";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import { Swiper, SwiperSlide } from "swiper/react";

const Team = ({ dataList }) => {
  const slideRef = useRef();
  const prevHandler = () => {
    slideRef?.current?.swiper?.slidePrev();
  };
  const nextHandler = () => {
    slideRef?.current?.swiper?.slideNext();
  };

  return (
    <Fragment>
      <section className="team_sec p_t">
        <div className="half a"></div>
        <div className="half b"></div>
        <div className="content_wrap">
          <div className="title_line">
            <div className="left">
              <motion.h2
                initial={{ translateY: 32, opacity: 0 }}
                whileInView={{ translateY: 0, opacity: 1 }}
                transition={{
                  duration: 0.6,
                  ease: "easeInOut",
                  delay: 0.15,
                }}
                viewport={{ once: true }}
              >
                Our
                <br />Board Members
 
              </motion.h2>
            </div>
          </div>

          {dataList?.length > 0 && (
            <div className="team_slider p_t">
              <Swiper
                ref={slideRef}
                loop={true}
                spaceBetween={16}
                slidesPerView={4}
                breakpoints={{
                  900: {
                    slidesPerView: 4,
                  },
                  600: {
                    slidesPerView: 2,
                  },
                  10: {
                    slidesPerView: 1,
                  },
                }}
              >
                {[...dataList, ...dataList]?.map((data, l) => {
                  return (
                    <SwiperSlide key={`${data._id}${l}`}>
                      <div className="team_card">
                        <div className="img_wrap">
                          <img src={`${baseUrl}/${data?.image}`} alt="Team" />
                          <div className="overlay">
                            {data?.link?.map((item) => {
                              return (
                                <Fragment key={item?._id}>
                                  {item?.link_name === "Facebook" && (
                                    <a href={item?.link} target="_blank">
                                      <FaFacebookF />
                                    </a>
                                  )}

                                  {item?.link_name === "Twitter" && (
                                    <a href={item?.link} target="_blank">
                                      <FaXTwitter />
                                    </a>
                                  )}

                                  {item?.link_name === "Linkedin" && (
                                    <a href={item?.link} target="_blank">
                                      <FaLinkedinIn />
                                    </a>
                                  )}
                                </Fragment>
                              );
                            })}
                          </div>
                        </div>
                        <div className="name_wrap">
                          <p>{data?.name}</p>
                          {data?.position && <p>{data?.position}</p>}
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
              <div className="controles">
                <button
                  type="button"
                  className="pill_btn"
                  onClick={prevHandler}
                >
                  <HiOutlineArrowNarrowLeft />
                </button>
                <button
                  type="button"
                  className="pill_btn"
                  onClick={nextHandler}
                >
                  <HiOutlineArrowNarrowRight />
                </button>
              </div>
            </div>
          )}
        </div>
      </section>
    </Fragment>
  );
};

export default Team;
